<template>
    <div class="app-container">
        <el-skeleton v-if="pageLoading" :rows="20" animated />
        <div v-else class="content-container">
            <div style="display:flex; justify-content:flex-end;">
                <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
                </el-date-picker>
            </div>

            <div class="platform-data">
                <h3>平台数据</h3>
                <div class="box-container">
                    <div class="data-box pv">
                        <h5 class="box-title">PV</h5>
                        <p class="box-ctn">{{ platform.PV }}</p>
                    </div>
                    <div class="data-box uv">
                        <h5 class="box-title">UV</h5>
                        <p class="box-ctn">{{ platform.UV }}</p>
                    </div>
                    <div class="data-box sp-pv">
                        <h5 class="box-title">商品PV</h5>
                        <p class="box-ctn">{{ platform.sp_PV }}</p>
                    </div>
                    <div class="data-box sp-uv">
                        <h5 class="box-title">商品UV</h5>
                        <p class="box-ctn">{{ platform.sp_UV }}</p>
                    </div>
                    <div class="data-box banner">
                        <h5 class="box-title">banner点击数</h5>
                        <p class="box-ctn">{{ platform.banner }}</p>
                    </div>
                    <div class="data-box sj">
                        <h5 class="box-title">商家数量</h5>
                        <p class="box-ctn">{{ platform.store_num }}</p>
                    </div>
                    <div class="data-box cp_sl">
                        <h5 class="box-title">累计测评数量</h5>
                        <p class="box-ctn">{{ platform.recommend_num }}</p>
                    </div>
                    <div class="data-box dh_sp">
                        <h5 class="box-title">累计兑换商品数量</h5>
                        <p class="box-ctn">{{ platform.integral_num }}</p>
                    </div>
                    <div class="data-box hd">
                        <h5 class="box-title">已发布活动数量</h5>
                        <p class="box-ctn">{{ platform.activity_num }}</p>
                    </div>
                </div>
            </div>
            <div class="user-statistic">
                <h3>用户统计</h3>
                <div class="box-container">
                    <div class="data-box users">
                        <h5 class="box-title">用户数量</h5>
                        <p class="box-ctn">{{ userList.user_num }}</p>
                    </div>
                    <div class="data-box share">
                        <h5 class="box-title">分享注册</h5>
                        <p class="box-ctn">{{ userList.user_ionvitation_num }}</p>
                    </div>
                    <div class="data-box point">
                        <h5 class="box-title">参与积分兑换用户</h5>
                        <p class="box-ctn">{{ userList.user_commodity_num }}</p>
                    </div>
                    <div class="data-box cj-users">
                        <h5 class="box-title">参与抽奖用户</h5>
                        <p class="box-ctn">{{ userList.user_draw_num }}</p>
                    </div>
                    <div class="data-box cp_users">
                        <h5 class="box-title">参与测评用户</h5>
                        <p class="box-ctn">{{ userList.user_recommend_num }}</p>
                    </div>
                </div>
            </div>
            <div class="operation-statistic">
                <h3>运营统计</h3>
                <div class="box-container">
                    <div class="data-box zs-jf">
                        <h5 class="box-title">已送出积分</h5>
                        <p class="box-ctn">{{ integral.integral_give }}</p>
                    </div>
                    <div class="data-box x-jf">
                        <h5 class="box-title">已核销积分</h5>
                        <p class="box-ctn">{{ integral.integral_expenditure }}</p>
                    </div>
                    <div class="data-box tx">
                        <h5 class="box-title">已提现积分</h5>
                        <p class="box-ctn">{{ integral.integral_withdrawal }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { quantityStatistic } from "@/api/statistic"

export default {
    data: () => ({
        platform: {},
        userList: {},
        integral: {},
        queryFilter: {
            start_at: null,
            end_at: null
        },
        pageLoading: false,
        filteDateRange: null
    }),
    methods: {
        async getData() {
            this.pageLoading = true
            const { data } = await quantityStatistic(this.queryFilter)
            this.platform = data.platform
            this.userList = data.userList
            this.integral = data.integral
            this.pageLoading = false
        },
        onChangeDateRange(t) {
            if (t === null) {
                this.queryFilter.start_at = null
                this.queryFilter.end_at = null
            } else {
                this.queryFilter.start_at = t[0]
                this.queryFilter.end_at = t[1]
            }

            this.getData()
        },
    },
    created() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.user-statistic,
.operation-statistic {
    margin-top: 30px;
}

.box-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // column-gap: 10px;
    // grid-template-columns: repeat(7, 1fr);
    margin: -10px;

    .data-box {
        width: 200px;
        height: 100px;
        border-radius: var(--border-radius);
        // background: #f1f1f3;
        box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 3%);
        border-radius: 0.75rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px;
        margin: 10px;

        .box-title {
            margin: 0;
            margin-top: 19px;
        }

        .box-ctn {
            font-size: 22px;
            font-family: "PingFangSC-Semibold, PingFang SC";
            font-weight: 600;
            color: #333;
            // text-align: center;
        }
    }
}

.pv {
    background: url("../../../icons/background/PV.svg");
}

.uv {
    background: url("../../../icons/background/UV.svg");
}

.sp-pv {
    background: url("../../../icons/background/sp_PV.svg");
}

.sp-uv {
    background: url("../../../icons/background/sp_UV.svg");
}

.banner {
    background: url("../../../icons/background/banner.svg");
}

.sj {
    background: url("../../../icons/background/sj.svg");
}

.cp_sl {
    background: url("../../../icons/background/cp_sl.svg");
}

.dh_sp {
    background: url("../../../icons/background/dh_sp.svg");
}

.hd {
    background: url("../../../icons/background/hd.svg");
}

.users {
    background: url("../../../icons/background/users.svg");
}

.share {
    background: url("../../../icons/background/share.svg");
}

.point {
    background: url("../../../icons/background/point.svg");
}

.cj-users {
    background: url("../../../icons/background/cj.svg");
}

.cp_users {
    background: url("../../../icons/background/cp_users.svg");
}

.zs-jf {
    background: url("../../../icons/background/s_jf.svg");
}

.x-jf {
    background: url("../../../icons/background/x_jf.svg");
}

.tx {
    background: url("../../../icons/background/tx.svg");
}
</style>